import NeighborhoodPage from "@/components/NeighborhoodPage";
import heroImage from "@/assets/hero-tijuca.jpg?w=640;1024;1600;1920&format=avif;webp;jpg&as=picture";

const Tijuca = () => (
  <NeighborhoodPage
    name="Tijuca"
    slug="tijuca"
    description="Tradição e qualidade de vida com fácil acesso a todas as regiões do Rio. Bairro arborizado com excelente infraestrutura e comércio diversificado."
    heroPicture={heroImage}
  />
);

export default Tijuca;
